"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Table_1 = require("./Table");
exports.default = Table_1.default;
//# sourceMappingURL=index.js.map